import { StripeCard } from "@/api/opb/opbTypes";
import {
  Tag,
  TagVariant,
  TextButton,
  CardLogo,
} from "@industriousoffice/react-components";
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";
import { getCardBrandFromStripe } from "@/utils/stripe";

export function StripeCreditCardInfo({
  paymentMethod,
  withEdit,
  footer,
}: {
  paymentMethod: StripeCard;
  withEdit?: boolean;
  footer?: ReactNode;
}) {
  const { t } = useTranslation("paymentMethods");
  const isExpired =
    paymentMethod.expYear < new Date().getFullYear() ||
    (paymentMethod.expYear === new Date().getFullYear() &&
      paymentMethod.expMonth < new Date().getMonth() + 1); // month in js starts at 0

  return (
    <>
      <div className="pt-1 grow-0">
        <CardLogo cardType={getCardBrandFromStripe(paymentMethod.cardType)} />
      </div>
      <div className="relative flex-wrap w-24 pl-3 text-left grow shrink-0">
        <div className="items-center pr-2 font-bold wrap-break-word md:block lg:flex">
          {t(paymentMethod.cardType)}&nbsp;
          <span className="font-normal">**** {paymentMethod.cardNumber}</span>
          {paymentMethod.default && (
            <Tag
              text={t("Default")}
              variant={TagVariant.Info}
              className="h-5 mx-2 font-normal rounded-sm"
            />
          )}
        </div>
        <div className={`pt-1 text-sm ${isExpired ? "text-red-500" : ""}`}>
          {isExpired ? t("Expired") : t("Expires")} {paymentMethod.expMonth}/
          {paymentMethod.expYear}
        </div>
        {withEdit ? (
          <TextButton
            type="button"
            className="absolute top-1 right-3"
            testId={`credit-card-edit_${paymentMethod.id}-btn`}
          >
            {t("Edit")}
          </TextButton>
        ) : null}
        {footer}
      </div>
    </>
  );
}
